import { render, staticRenderFns } from "./InfectorsVsNon.vue?vue&type=template&id=2dc5f86b"
import script from "./InfectorsVsNon.vue?vue&type=script&lang=js"
export * from "./InfectorsVsNon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports